export default {
    // User global selections
    get_steps: state => {
        return state.steps;
    },
    get_selection: state => {
        return state.selection;
    },
    get_max_panels: state => {
        return state.maxPanels;
    },
    // Get notification
    get_notification: state => {
        return state.notification;
    },
    get_wording: state => {
        return state.wording;
    },
    get_supplier: state => {
        return state.supplier;
    },
    // Get loader
    get_loader: state => {
        return state.loader;
    },
    // Building, field panel getters
    get_buildings: state => {
        return state.buildings;
    },
    get_building_by_id: state => id => state.buildings.filter(building => building.id === id)[0],
    get_selected_building_slug: (state, getters) => {
        let slug = '';
        if (getters.get_building_info) {

            let buildingAddress = getters.get_building_info.address;
            slug = sanitizeString(buildingAddress);
        }
        return slug;
    },
    get_building_by_slug: (state, getters) => slug => {
        let foundBuilding = null;

        for (let i = 0; i < getters.get_buildings.length; i++) {
            let building = getters.get_buildings[i];
            if (sanitizeString(building.address) === slug) {
                foundBuilding = building;
                break;
            }
        }

        return foundBuilding;
    },
    get_fileds: state => {
        var building = state.buildings.filter(element => element.id === state.selection.activeBuilding);
        if (building.length > 0) { return building[0].fields; }
    },
    // get panels from selected field
    get_panels: state => {
        return state.panels;
    },
    // Get building info
    get_building_info: state => {
        for (var ii = 0; ii < state.buildings.length; ii++) {
            if (state.buildings[ii].id === state.selection.activeBuilding) {
                return state.buildings[ii];
            }
        }
    },
    // Get selected panels
    get_selected_panels: state => {
        var selectedArr = [];
        for (var ii = 0; ii < state.panels.length; ii++) {
            if (state.panels[ii].selected === true) {
                selectedArr.push(state.panels[ii]);
            }
        }
        return selectedArr;
    },
    get_panel_by_id: state => id => {
        return state.panels.find(el => el.id === id);
    },
    get_field_by_id: (state, getters) => id => {
        return getters.get_building_info.fields.find(el => el.id === id);
    },
    get_selected_panels_ids: state => {
        var selectedArr = [];
        for (var ii = 0; ii < state.panels.length; ii++) {
            if (state.panels[ii].selected === true) {
                selectedArr.push(state.panels[ii].id);
            }
        }
        return selectedArr;
    },
    // Get owner by id
    get_owner: state => id => {
        let panelOwner = state.panels.find(panel => panel.id === id);
        return panelOwner.owner;
    },
    // Get customer
    get_customer: state => {
        return state.customer;
    },
    // Get order
    get_order_created: state => {
        return state.orderCreated;
    },
    // Get pdf
    get_pdf: state => {
        return state.pdf;
    }
};

function sanitizeString (stringToSanitize) {
    let slug = '';
    // Change to lower case
    let titleLower = stringToSanitize.toLowerCase();
    // Letter "e"
    slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
    // Letter "a"
    slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
    // Letter "o"
    slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
    // Letter "u"
    slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
    // Letter "d"
    slug = slug.replace(/đ/gi, 'd');
    // Trim the last whitespace
    slug = slug.replace(/\s*$/g, '');
    // Change whitespace to "-"
    slug = slug.replace(/\s+/g, '-');
    return slug;
}



// WEBPACK FOOTER //
// ./src/store/getters.js